module.exports = __webpack_public_path__ + "img/home-solution-shuili.89c35684.png";